module.exports = __webpack_public_path__ + "img/fk.519e3de.svg";